import C_GameEvt from "../const/C_GameEvent";

/**
 * Application model. Stores the game state.
 */
class Model
{


    constructor()
    {
        this.app = PIXI.app;
        this.mobile = /Mobi/.test(navigator.userAgent);
        this.android = /android/i.test(navigator.userAgent);
        this.idCounter = 0;

        this.balance = 0;
        this.coinsRate = 0;
        this.coinsWon = 0;
        this.currencyMultiplier = 0;

        this.bots = {};
    }


    getUID()
    {
        return this.idCounter++;
    }


    /**
     * Is the device mobile ?
     * @public
     * @returns {Boolean}
     */
    isMobile()
    {
        return this.mobile;
    }


    /**
     * Is the device running Android ?
     * @returns {Boolean}
     */
    isAndroid()
    {
        return this.android;
    }


    init(data)
    {
        this.setBalance(data);
        this.setCoinsRate(data);
        this.setCurencyMultiplier(data);
    }


    setRoomData(data)
    {
        this.rooms = data.result.rooms;
    }


    getRoomData()
    {
        return this.rooms;
    }


    setBalance(data)
    {
        this.currency = data.balance.currency;
        this.balance = data.balance.amount;
    }


    setSelectedRoomData(data)
    {

    }


    getProjectileVelocity()
    {
        return 150;
    }


    getRoomId()
    {
        return this.roomId;
    }


    setRoomId(roomId)
    {
        this.roomId = roomId;
    }


    setBet(val)
    {
        this.bet = val;
    }


    getBet()
    {
        return this.bet;
    }


    makeBet()
    {
        let canShoot = true;
        if (this.balance < this.getBet())
        {
            canShoot = false;
            this.app.dispatcher.emit(C_GameEvt.SHOW_GAME_OVER);
        }
        else
        {
            this.balance -= this.getBet();
            this.app.dispatcher.emit(C_GameEvt.BALANCE_UPDATE);
        }
        return canShoot;
    }


    getBalance()
    {
        return this.balance;
    }


    setCoinsRate(data)
    {
        this.coinsRate = data.result.settings.coinsRate;
    }


    getCoinsRate()
    {
        return this.coinsRate;
    }


    setCurencyMultiplier(data)
    {
        this.currencyMultiplier = data.result.settings.currencyMultiplier;
    }


    getCurrencyMultiplier()
    {
        return this.currencyMultiplier;
    }


    setFireResponse(data)
    {
        if (data.result.coins_amount && data.result.coins_amount > 0)
        {
            this.balance += data.result.coins_amount;
            this.coinsWon += data.result.coins_amount;
            this.app.dispatcher.emit(C_GameEvt.BALANCE_UPDATE);
        }

        this.rewards = data.result.rewards;
    }


    setBot(bot)
    {
        this.bots[bot.botId] = bot;
    }


    getBot(botId)
    {
        return this.bots[botId];
    }


    pause()
    {
        this.isPaused = true;
    }


    unpause()
    {
        this.isPaused = false;
    }


    getPause()
    {
        return this.isPaused;
    }

}


export default Model;